import { render, staticRenderFns } from "./batch_orders_expand.vue?vue&type=template&id=7b3cfcd9&scoped=true"
import script from "./batch_orders_expand.vue?vue&type=script&lang=js"
export * from "./batch_orders_expand.vue?vue&type=script&lang=js"
import style0 from "./batch_orders_expand.vue?vue&type=style&index=0&id=7b3cfcd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3cfcd9",
  null
  
)

export default component.exports